import React, { FC } from 'react';
import { TailSpin } from 'react-loader-spinner';
import cn from 'classnames';
import './styles.scss';

const HEIGHT = 100;
const WEIGHT = 100;
const DEFAULT_COLOR = '#3a89f7';

interface ILoader {
  color?: string;
  fullScreen?: boolean;
  className?: string;
}

const Loader: FC<ILoader> = ({ color = DEFAULT_COLOR, fullScreen = false, className }) => (
  <div className={cn('hbh-loader', { 'hbh-loader--full-screen': fullScreen }, className)}>
    <TailSpin color={color} height={HEIGHT} width={WEIGHT} />
  </div>
);

export default Loader;
